/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { LicenseAgreementDetailsDto, LicenseAgreementListItemDto, LicenseAgreementType } from '@gh/builder-shared-data';
import { EMPTY_ID } from '@gh/common-shared-data';

export type LicenseAgreementListItem = LicenseAgreementListItemDto;
export type LicenseAgreementDetails = LicenseAgreementDetailsDto;

export const newLicenseAgreementDetails = (): LicenseAgreementDetails => <any>({
  id: EMPTY_ID,
  name: '',
  description: '',
  isActive: false,
  eula: '',
  systemRole: LicenseAgreementType.Franchisee,
  confirmations: {
    skipRelevanceCheck: false,
  },
});
